import React from 'react';
import {Button, Form, Row, Col, Select, Input} from 'antd';
import {actions, asyncList} from './reducers';
import {connect} from 'react-redux';
import moment from 'moment';
import 'moment/locale/zh-cn';

moment.locale('zh-cn');

const FormItem = Form.Item;

const spans = {
    xs: 14,
    sm: 14,
    md: 4,
    lg: 4,
    xl: 4,
};

class Search extends React.Component {

    constructor(props) {
        super(props);
    }


    componentDidMount(){
        this.props.form.resetFields();
    }

    handleReset = () => {
        this.props.form.resetFields();
    }

    // 查询
    handleSearch = () => {
        let values = this.props.form.getFieldsValue();
        for (let i in values) {
            if (values[i] === -1 || values[i] === '' || values[i] === undefined) {
                delete values[i];
            }
        }
        console.log('=====searchValue', values);
        this.props.changeSearchValues(values);
        this.props.asyncList();
    }


    render() {
        const {getFieldDecorator} = this.props.form;
        return (
            <div>
                <h2 style={{marginBottom: '20px'}}>任务追踪管理</h2>
                <Form inline={true} onSubmit={this.handleSearch} className="searchWrapper">
                    <Row style={{marginBottom: '10px'}}>
                        <Col span={4}>
                            <FormItem {...spans} label="订单id">
                                {getFieldDecorator('eId')(<Input placeholder="请填写订单id"
                                                                                  style={{width: '100%'}}/>)}
                            </FormItem>
                        </Col>

                        <Col span={4}>
                            <FormItem {...spans} label="任务id">
                                {getFieldDecorator('taskId')(<Input placeholder="请填写任务id"
                                                                                  style={{width: '100%'}}/>)}
                            </FormItem>
                        </Col>

                        <Col span={4}>
                            <FormItem {...spans} label="uuid">
                                {getFieldDecorator('uuid')(<Input placeholder="请填写uuid"
                                                                                  style={{width: '100%'}}/>)}
                            </FormItem>
                        </Col>

                        <Col span={4}>
                            <FormItem label="状态" {...spans}>
                                {getFieldDecorator('code')(
                                    <Select allowClear placeholder="全部" style={{width: 160}}>
                                        <Option key='200' value={200}>
                                            处理成功
                                        </Option>
                                        <Option key='10000' value={10000}>
                                            系统错误
                                        </Option>
                                        <Option key='10001' value={10001}>
                                            没有代理
                                        </Option>
                                        <Option key='10002' value={10002}>
                                            没有设备
                                        </Option>
                                        <Option key='10003' value={10003}>
                                            没有素材
                                        </Option>
                                        <Option key='10004' value={10004}>
                                            结束标志错误
                                        </Option>
                                        <Option key='10005' value={10005}>
                                            任务分配失败
                                        </Option>
                                        <Option key='10006' value={10006}>
                                            任务执行失败
                                        </Option>
                                    </Select>,
                                )}
                            </FormItem>
                        </Col>

                        <Col span={4}>
                            <FormItem label="分派时间" {...spans}>
                                {getFieldDecorator('assignTimeStatus', {
                                    initialValue: 1,
                                })(
                                    <Select placeholder="全部" style={{width: 160}} defaultValue={1}>
                                        <Option key='1' value={1}>
                                            最近2分钟
                                        </Option>
                                        <Option key='2' value={2}>
                                            最近5分钟
                                        </Option>
                                        <Option key='3' value={3}>
                                            最近10分钟
                                        </Option>
                                        <Option key='4' value={4}>
                                            最近1小时
                                        </Option>
                                        <Option key='5' value={5}>
                                            全部
                                        </Option>
                                    </Select>,
                                )}
                            </FormItem>
                        </Col>
                    </Row>

                    <Row>
                        <Col span={24} style={{textAlign: 'right', marginTop: '10px', marginBottom: '20px'}}>
                            <Button style={{margin: '0 8px'}} onClick={this.handleReset}>
                                重置
                            </Button>
                            <Button type="primary" style={{margin: '0 8px'}} onClick={this.handleSearch}>
                                搜索
                            </Button>
                        </Col>
                    </Row>
                </Form>
            </div>
        );
    }
}

const mapDispatchToProps = dispatch => ({
    changeSearchValues: values => dispatch(actions.changeSearchValues(values)),
    asyncList: () => dispatch(asyncList()),
    editShow: () => dispatch(actions.changeUiStatus({isUpdateShow: true})),
});

export default connect(null, mapDispatchToProps)(Form.create()(Search));



// WEBPACK FOOTER //
// ./pages/assist/logCollect/search.js